import utils from "@/stuff/Utils";
import { mapData } from "@/stuff/DataMapping";
import { LookupItem } from "./LookupItem";

export interface ICertificate {
    id: number;
    supplierID: number;
    supplierResponseSetID: number;
    supplierName: string;
    supplierAddress: string;
    certificateTypeID: number;
    schemeName: string;
    trade: string;
    cdmCategory: string;
    expiry: Date;
    approval: Date;
    numberOfPersonnel: number;
    visibleToBuyerIDs: Array<number>;
    created: Date;
    createdByUserID: number;
    lastModified: Date;
    lastModifiedByUserID: number;
    archived: Date;
    archivedByUserID: number;
}

export class Certificate implements ICertificate {

    constructor(data?: ICertificate) {
        if (data) this.update(data);
    }

    update(data: ICertificate) {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    supplierID: number = 0;
    supplierResponseSetID: number = 0;
    supplierName: string = "";
    supplierAddress: string = "";
    certificateTypeID: number = 0;
    schemeName: string = "";
    trade: string = "";
    cdmCategory: string = "";
    expiry: Date = new Date(utils.emptyDateValue);
    approval: Date = new Date(utils.emptyDateValue);
    numberOfPersonnel: number = 0;
    visibleToBuyerIDs: Array<number> = [];
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: number = 0;
    lastModified: Date = new Date(utils.emptyDateValue);
    lastModifiedByUserID: number = 0;
    archived: Date = new Date(utils.emptyDateValue);
    archivedByUserID: number = 0;

    get isNew() {
        return utils.isEmptyId(this.id);
    }

    get isArchived() {
        return utils.hasDateValue(this.archived);
    }

    get number() {
        return utils.pad(this.supplierID, 5) + "-" + utils.pad(this.id, 4);
    }

    get description() {
        return this.supplierName + " - " + this.number;
    }

    get expired(): boolean {
        return utils.hasDateValue(this.expiry) && this.expiry < new Date();
    }
}